<template>
    <ul>
        <li class="menu__item">
            <router-link :to="{ name: 'markets' }" class="menu__link">
                <i class="mdi mdi-arrow-left"></i>
                <span>Back</span>
            </router-link>
            <!--<router-link :to="{ name: 'home' }" @click.native="toggleMobileMenu" class="menu__link">-->
            <!--</router-link>-->
        </li>
        <li class="menu__item divider--before">
            <router-link :to="{ name: 'market-dashboard' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-chevron-right"></i>
                <span>Dashboard</span>
            </router-link>
        </li>
        <li class="menu__item">
            <router-link :to="{ name: 'market-stands' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Ondernemers</span>
            </router-link>
        </li>
        <li class="menu__item">
            <router-link :to="{ name: 'market-requests' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Aanvragen</span>
            </router-link>
        </li>
        <li class="menu__item">
            <router-link :to="{ name: 'market-recruitment' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Werving</span>
            </router-link>
        </li>
        <li class="menu__item">
            <router-link :to="{ name: 'market-notes' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Notities</span>
            </router-link>
        </li>
        <li class="menu__item divider--before">
            <router-link :to="{ name: 'market-users' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Gebruikers</span>
            </router-link>
        </li>
    </ul>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vMediaQuery from 'v-media-query';

    import firebase from 'firebase';

    @Component({
    })
    export default class MarketMenu extends Vue {
        name = 'market-menu';

        showMobileMenu = true;

        logout() {
        }

        toggleMobileMenu() {

        }
    }

    Vue.component('market-menu', MarketMenu);
</script>

<style src="./styles.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/general/menu/Market.vue